import type {QueryHookOptions} from '@apollo/client';

import {useStatQuery} from 'web-app/react/staffing-attendance/hooks/queries/use-stat-query';
import {type ImmerWrappedQueryResult} from 'web-app/react/staffing-attendance/hooks/use-immer-query-wrapper';

import {FetchFinanceFeatures} from '../graphql/fetch-finance-features.query';
import {
    type FetchFinanceFeaturesQuery,
    type FetchFinanceFeaturesQueryVariables,
} from '../graphql/__generated__/fetch-finance-features.query.api-types';

// Use cache-first for finance features as they are relatively static configuration data
// that doesn't change frequently, reducing unnecessary network requests
const fetchPolicy = 'cache-first';

export function useFetchFinanceFeaturesQuery(
    options: QueryHookOptions<FetchFinanceFeaturesQuery, FetchFinanceFeaturesQueryVariables>,
): ImmerWrappedQueryResult<FetchFinanceFeaturesQuery, FetchFinanceFeaturesQueryVariables> {
    const queryResult = useStatQuery(FetchFinanceFeatures, {
        fetchPolicy,
        ...options,
    });

    return queryResult;
}

export type UseFetchFinanceFeaturesQueryType = ReturnType<typeof useFetchFinanceFeaturesQuery>['data'];
